"use strict";

exports.__esModule = true;
exports.default = exports.themes = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: ", ";\n\tpadding: 0.5rem;\n\t", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tbackground-color: ", ";\n\t\tcolor: white;\n\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var theme = {
  default: (0, _styledComponents.css)(_templateObject(), _colors.default.greyLight, _colors.default.textColor),
  warning: (0, _styledComponents.css)(_templateObject2(), _colors.default.error),
  success: (0, _styledComponents.css)(_templateObject3(), _colors.default.success, _colors.default.textColor)
};

var Alert = _styledComponents.default.div(_templateObject4(), _vars.default.borderRadius, function (props) {
  return theme[props.type];
});

Alert.displayName = 'Alert';
var themes = {
  default: 'default',
  warning: 'warning',
  success: 'success'
};
exports.themes = themes;
Alert.propTypes = {
  type: (0, _propTypes.oneOf)(Object.keys(themes)),
  children: _propTypes.node.isRequired
};
Alert.defaultProps = {
  type: 'default'
};

/* @component */
var _default = Alert;
exports.default = _default;